import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-lg font-bold mb-4">91影视看片app</h4>
            <p className="text-foreground-300 text-sm leading-relaxed">
              免费高清影视在线观看平台，支持安卓和苹果设备。海量影视资源每日更新，随时随地畅享观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/" className="text-foreground-300 text-sm hover:text-white transition-colors duration-200">首页</Link></li>
              <li><Link to="/category" className="text-foreground-300 text-sm hover:text-white transition-colors duration-200">影视分类</Link></li>
              <li><Link to="/article/latest" className="text-foreground-300 text-sm hover:text-white transition-colors duration-200">资讯文章</Link></li>
              <li><Link to="/about" className="text-foreground-300 text-sm hover:text-white transition-colors duration-200">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">下载方式</h4>
            <ul className="flex flex-col gap-2">
              <li><a href="#download" className="text-foreground-300 text-sm hover:text-white transition-colors duration-200 cursor-pointer">安卓版下载</a></li>
              <li><a href="#download" className="text-foreground-300 text-sm hover:text-white transition-colors duration-200 cursor-pointer">苹果版下载</a></li>
              <li><a href="#download" className="text-foreground-300 text-sm hover:text-white transition-colors duration-200 cursor-pointer">安装教程</a></li>
              <li><a href="#download" className="text-foreground-300 text-sm hover:text-white transition-colors duration-200 cursor-pointer">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2">
              <li className="text-foreground-300 text-sm">
                <i className="ri-mail-line mr-2"></i>support@91yingshi.com
              </li>
              <li className="text-foreground-300 text-sm">
                <i className="ri-customer-service-2-line mr-2"></i>在线客服：7x24小时
              </li>
              <li className="text-foreground-300 text-sm">
                <i className="ri-shield-check-line mr-2"></i>安全无毒，放心使用
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-10 pt-8 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; 2026 91影视看片app. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 text-xs hover:text-white transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#" className="text-foreground-400 text-xs hover:text-white transition-colors duration-200" rel="nofollow">用户协议</a>
            <a href="#" className="text-foreground-400 text-xs hover:text-white transition-colors duration-200" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}